import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  TextInput,
  StyleSheet,
  CheckBox,
  Platform,
} from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import UpgradeComponent from "../home-common-components/UpgradeComponent";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { getLoginData } from "../../utility/AppStoreData";
import { useAuthProvider } from "../../context/AuthContext";

const CheckoutScreen = () => {
  const deviceSize = useDeviceSize();
  const [userData, setUserData] = useState(null);
  const { isActiveSubscriptionFound } = useAuthProvider();

  useEffect(() => {
    getLoginUserData();
  }, []);
  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
    }
  }
  return (
    <View style={styles.container}>
      <View>
        <Text
          style={[
            AppFontStyle.REGULAR_ANYBODY_18,
            {
              textAlign: "right",
            },
          ]}
        >
          Available Credit: 23450
        </Text>
      </View>
      <View style={styles.checkoutContainer}>
        <Text style={[AppFontStyle.REGULAR_ANYBODY_18, { paddingBottom: 30 }]}>
          Checkout:
        </Text>
        <View style={styles.inputRow}>
          <Text style={styles.label}>Credit</Text>
          <TextInput
            style={[AppFontStyle.REGULAR_ANYBODY_18, styles.input]}
            placeholder="6500"
            rdType="numeric"
          />
        </View>

        <View style={styles.inputRow}>
          <Text style={styles.label}>Balance</Text>

          <TextInput
            style={[AppFontStyle.REGULAR_ANYBODY_18, styles.input]}
            placeholder="$98.89"
            editable={false}
          />
        </View>
        <View
          style={{
            flexDirection:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "column"
                : "row",
            gap: 10,
          }}
        >
          <View
            style={{
              backgroundColor: AppColors.gray_1E1E1E,
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 310
                  : 176,
              height: 78,
              marginBottom: 15,
              borderRadius: 10,
              justifyContent: "space-between",
            }}
          >
            <Text
              style={{
                color: AppColors.gray_C3C3C3,
                paddingTop: 5,
                paddingLeft: 15,
              }}
            >
              Exchange Rate
            </Text>
            <View>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_18,
                  { paddingLeft: 15, marginBottom: 10 },
                ]}
              >
                {" "}
                1 credit = $0.0145
              </Text>
            </View>
          </View>
          <View
            style={{
              backgroundColor: AppColors.gray_1E1E1E,
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 310
                  : 289,
              height: 78,
              marginBottom: 15,
              borderRadius: 10,
              justifyContent: "space-between",
            }}
          >
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  color: AppColors.gray_C3C3C3,
                  paddingTop: 5,
                  paddingLeft: 15,
                }}
              >
                Subscription status:
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_16,
                  {
                    color: AppColors.white,
                    paddingTop: 10,
                  },
                ]}
              >
                {isActiveSubscriptionFound ? "subscribed" : "Not subscribed"}
              </Text>
            </View>
            {!isActiveSubscriptionFound && (
              <View style={{ alignItems: "center" }}>
                <UpgradeComponent styles={styles} />
              </View>
            )}
          </View>
        </View>
        <View
          style={{
            flexDirection:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "column"
                : "row",
            gap: 10,
          }}
        >
          <View>
            <View style={styles.inputRow}>
              <Text style={styles.label}>Platform fees: </Text>

              <TextInput
                style={[AppFontStyle.REGULAR_ANYBODY_18, styles.input]}
                placeholder="50%"
                editable={false}
              />
            </View>

            <View style={styles.inputRow}>
              <Text style={styles.label}>you will receive </Text>

              <TextInput
                style={[AppFontStyle.REGULAR_ANYBODY_18, styles.input]}
                placeholder="$44.449"
                editable={false}
              />
            </View>
          </View>
          <Text style={AppFontStyle.REGULAR_ANYBODY_18}>
            Upgrade now to keep 80% of your winnings (compared to 50% for
            non-subscribers) and enjoy faster issue resolution with priority
            customer support and more!
          </Text>
        </View>
      </View>

      <View
        style={{
          flexDirection:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "column"
              : "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 10
              : 0,
          marginBottom: 10,
        }}
      >
        <View style={{ flexDirection: "row", gap: 10 }}>
          <CheckBox
            value={true}
            // onValueChange={() => handleSelectOption("Card")}
            // style={styles.checkBox}
          />
          <Text style={styles.footerText}>Use a secure HTTPS connection</Text>
        </View>

        <TouchableOpacity style={styles.confirmButton}>
          <Text style={styles.confirmText}>Confirm payment</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#121212",
    justifyContent: "center",
  },
  checkoutContainer: {
    marginBottom: 20,
  },
  label: {
    color: AppColors.gray_C3C3C3,
    position: "absolute",
    top: 7,
    left: 15,
  },
  inputRow: {
    position: "relative",
    marginBottom: 15,
    borderRadius: 10,
  },
  inputStatusRow: {
    position: "relative",
    marginBottom: 15,
    borderRadius: 10,
  },
  upgradeBtn: {
    flexDirection: "row",
    backgroundColor: AppColors.blue_5145E2,
    alignItems: "center",
    borderRadius: 10,
    paddingHorizontal: 18,
    marginBottom: 5,
    position: "relative",
    width: 175,
    height: 39,
  },
  input: {
    width: 310,
    height: 38,
    backgroundColor: AppColors.gray_1E1E1E,
    borderRadius: 5,
    paddingVertical: Platform.OS === "ios" ? 10 : 5,
    paddingHorizontal: 15,
    color: "#ffffff",
    textAlign: "right",
  },
  rateInput: {
    width: 176,
    height: 78,
    backgroundColor: "#2E2E2E",
    borderRadius: 5,
    paddingVertical: Platform.OS === "ios" ? 10 : 5,
    paddingHorizontal: 15,
    color: "#ffffff",
    // textAlign: "right",
  },
  value: {
    color: "#ffffff",
    fontSize: 14,
  },
  subscriptionContainer: {
    // backgroundColor: "#2E2E2E",
    padding: 15,
    borderRadius: 5,
    marginBottom: 20,
  },
  subscriptionLabel: {
    color: "#ffffff",
    marginBottom: 10,
  },
  notSubscribed: {
    color: "#FF0000",
  },
  confirmButton: {
    backgroundColor: AppColors.appViolentColor_6D08C3,
    borderRadius: 10,
    paddingVertical: 15,
    alignItems: "center",
    width: 212,
  },
  confirmText: {
    color: "#FFFFFF",
    fontWeight: "bold",
  },
  footerText: {
    color: AppColors.gray_C3C3C3,
    textAlign: "center",
    fontSize: 12,
  },
});

export default CheckoutScreen;
